export const MultiLangDomains = {
    be: [        
        {
            lang: 'fr',
            formatId: 'sidebar.lang.fr',
            formatDefaultMsg: 'French'
        },
        {
            lang: 'de',
            formatId: 'sidebar.lang.de',
            formatDefaultMsg: 'German'
        },
        {
            lang: 'be',
            formatId: 'sidebar.lang.be',
            formatDefaultMsg: 'Dutch'
        }
    ],
    ch: [
        {
            lang: 'de',
            formatId: 'sidebar.lang.de',
            formatDefaultMsg: 'German'
        },
        {
            lang: 'fr',
            formatId: 'sidebar.lang.fr',
            formatDefaultMsg: 'French'
        },
        {
            lang: 'en',
            formatId: 'sidebar.lang.en',
            formatDefaultMsg: 'English'
        },
        {
            lang: 'it',
            formatId: 'sidebar.lang.it',
            formatDefaultMsg: 'Italian'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/constants/multiLanguageSupport.js